import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HelpMenuItemComponent } from './help-menu-item/help-menu-item.component';
import { HelpMenuComponent } from './help-menu/help-menu.component';

import { HelpRoutingModule } from './help-routing.module';

@NgModule({
  declarations: [HelpMenuComponent, HelpMenuItemComponent],
  exports: [HelpMenuComponent],
  imports: [NgbModule, CommonModule, HelpRoutingModule],
})
export class HelpModule {}
